var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a style=\"display:none\"></a>";
var id1="winresDeparturesSearchEmpty.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparturesSearch/winresDeparturesSearchEmpty.html
// module id = 287
// module chunks = 2